import React, { useState, useEffect, useRef } from 'react';
import closeImg from './img/close.svg';
import PropTypes from 'prop-types';
import * as styles from './zoom.module.scss';
import cx from 'classnames';
import { useWindowSize } from '@hooks/useWindowSize';

export function Zoom({ data }) {
  const [isModalOpen, setModalOpen] = useState(false);
  const [isImageZoomed, setImageZoomed] = useState(false);
  const [isFlexInContainer, setFlexInContainer] = useState(false);
  const imageRef = useRef(null);
  const windowSize = useWindowSize();
  const [isHeightMoreThanWidth, setIsHeightMoreThanWidth] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setImageZoomed(false);
  };

  const zoomInImage = (e) => {
    e.stopPropagation();
    setImageZoomed((prevState) => !prevState);
  };

  const calculateImageSize = (e) => {
    setIsHeightMoreThanWidth(e.target.naturalHeight > e.target.naturalWidth);
  };

  const calculateHeightForImage = () => {
    return windowSize.width >= 840 && isHeightMoreThanWidth ? '100vh' : 'auto';
  };

  useEffect(() => {
    if (isModalOpen) {
      const currentHeight = imageRef.current.height;
      const currentWidth = imageRef.current.width; //equal to current window height (100vh)
      const proportion = currentWidth / currentHeight;
      const windowWidth = windowSize.width;
      const futureHeight = windowWidth / proportion;
      if (futureHeight < windowSize.height) {
        setFlexInContainer(true);
      }
    }
  }, [isModalOpen]);

  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'initial';
    }
    return () => {
      document.body.style.overflow = 'initial';
    };
  }, [isModalOpen]);

  return (
    <React.StrictMode>
      <div className={styles.wrapper}>
        <img className={styles.mainImage} loading="lazy" src={data.src} alt={data.alt} onClick={openModal} />
        {typeof window !== 'undefined' && isModalOpen && (
          <div
            aria-modal
            role="dialog"
            className={cx(styles.modalOverlay, { [styles.open]: isModalOpen, [styles.closed]: !isModalOpen })}
            onClick={closeModal}
          >
            <div
              className={cx(styles.modalContent, { [styles.zoomedImageContainer]: isImageZoomed })}
              style={{
                maxWidth: isHeightMoreThanWidth ? '50%' : '100%',
                display: isFlexInContainer ? 'flex' : 'block',
              }}
            >
              <img
                className={cx(styles.image, { [styles.zoomedImageImage]: isImageZoomed })}
                style={{ height: calculateHeightForImage() }}
                onLoad={calculateImageSize}
                onClick={zoomInImage}
                loading="lazy"
                src={data.src}
                alt={data.alt}
                ref={imageRef}
              />
              <img loading="lazy" src={closeImg} alt="close button" className={styles.closeBtn} onClick={closeModal} />
            </div>
          </div>
        )}
      </div>
    </React.StrictMode>
  );
}

Zoom.propTypes = {
  zoomMargin: PropTypes.number,
  transitionDuration: PropTypes.number,
  wrapElement: PropTypes.oneOf(['div', 'span', 'p']),
  getScale: PropTypes.func,
};
